export const headerId = "shared-header";

/**
 * Per-breakpoint classes for the floating variant's drawer/desktop swap. Kept
 * here as whole literals because Tailwind only sees class names it can read
 * statically — composing the width into the string would emit no CSS.
 */
export const floatingDrawerHidden = {
  default: "min-[1230px]:hidden",
  wide: "min-[1536px]:hidden",
} as const;

export const floatingDesktopShown = {
  default: "hidden min-[1230px]:flex",
  wide: "hidden min-[1536px]:flex",
} as const;
